import { Link } from "react-router-dom";
import { Boxes } from "lucide-react";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import TitleBand from "../../components/TitleBand/TitleBand";
import CtaBand from "../../components/Home/CtaBand";
import ContactForm from "../../components/Forms/ContactForm";
import ChatWidget from "../../components/ChatWidget/ChatWidget";
import ProductSection from "./ProductSection";
import ProductCore from "./ProductCore";
import { useProdutos } from "./ProdutosContent";
import { PageSeo } from "../../seo/Seo";
import "./Produtos.css";

// Mesmo padrão da página de Cases: título em faixa, atalhos e seções alternando branco e faixa clara (--band).
export default function Produtos() {
  const { t } = useTranslation();
  const { products, core } = useProdutos();
  const all = [...products.map(({ id, name }) => ({ id, name })), { id: core.id, name: core.name }];

  return (
    <div className="cz-page cz-scope cz-prod-page">
      <PageSeo page="produtos" path="/produtos" />
      <Header />
      <main>
        <TitleBand
          title={
            <>
              {t("produtos_page.hero.title_lead")}{" "}
              <span className="cz-prod-accent">{t("produtos_page.hero.title_accent")}</span>
            </>
          }
          icon={Boxes}
        />
        <nav className="cz-prod-nav" aria-label={t("produtos_page.labels.jump")}>
          <ul className="cz-prod-nav__list">
            {all.map(({ id, name }) => (
              <li key={id}>
                <Link to={`#${id}`} className="cz-prod-nav__link">
                  {name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {products.map((product, i) => (
          <ProductSection key={product.id} product={product} band={i % 2 === 1} />
        ))}
        <ProductCore core={core} band={products.length % 2 === 1} />

        <CtaBand />
        <ContactForm />
      </main>
      <ChatWidget />
    </div>
  );
}
